<template>
    <div class="desktopLayoutClass">
      <v-app>

        <!-- Header Start -->
        <div v-show="show_header" class="d-flex header" style="padding-top: 10px; padding-left: 5px;">
          <div class="d-flex" style="width: 100%">
              <div style="width: 10%; padding-top: 6px" align="left" v-on:click="goBack">
                  <img src="https://img.icons8.com/material-outlined/20/000000/left.png"/>
              </div>
              <div style="width: 90%" align="left">
                  <span class="headertext">Video Consultation</span>
              </div>
          </div>
        </div>
        <!-- Header End -->

        <div style="height: 200px; display: flex; align-items: center; flex-direction: column;  margin-top: 20px;">
            <p>
                The In-App Video Call feature is not supported. Kindly join the call using the provided link and PIN.
            </p>
            <p>We have sent SMS for the joining link and PIN. In case you have not recieved please copy from below. </p>
            <v-btn color="primary" @click="copyLinkDetails">Click To Copy Link</v-btn>
            <div v-if="isCopied">Copied</div>
            <p style="margin: 10px 10px">Please use the following pin to enter the room</p>
            <v-btn color="success">{{ PIN }}</v-btn>
        </div>
      </v-app>
    </div>
</template>
<script>
import axios from "axios";
export default{
    name: "VideoCallForThirdParty",
    data(){
        return{
          pageName: "VideoCallForThirdParty",
          isCopied: false,
          booking_id: '',
          PIN: '',
          show_header:true,

        }
    },
    mounted(){
        this.booking_id = this.$route.params.booking_id;
        this.PIN = this.$route.params.pin;
      if(this.$store.state.locale !== "")
      {
        this.$i18n.locale =  this.$store.state.locale;
      }
      else
      {
        this.$i18n.locale = "mm";
        this.$store.dispatch("changeLocale", this.$i18n.locale);
      }
      this.currentCustomer = this.$cookies.get("customerToken");
    },
    methods:{
      userPageViewTable() {
            if (this.currentCustomer === null) {
                var userPageViewTableBody = {
                pageName : 'viewDoctors',
                typeOfUser: 'CUSTOMER'
                }
            } else {
                var userPageViewTableBody = {
                pageName: 'viewDoctors',
                typeOfUser: 'CUSTOMER',
                token: this.currentCustomer
                }
            }
            axios.post(process.env.VUE_APP_BACKEND_URL+"/userPageViewTable", userPageViewTableBody)
            .catch((userPageViewTableError) => {
                console.log('[Error][userPageTableError] Error in adding userPageViewTable', userPageViewTableError);
            });
      },
        async copyLinkDetails() {
        let bookingID =  this.$route.params.booking_id;
        alert()

        let appointmentRoomLink = `${process.env.VUE_APP_TELEMEDICINE_FRONTEND_URL}/appointmentLink/${this.booking_id}`;
        let details = appointmentRoomLink;
        await this.copyToClipboard(details);
    },
    goBack() {
        this.$router.go(-1);
    },
    async copyToClipboard(text) {
        if (navigator.clipboard && window.isSecureContext) {
                try {
                 await navigator.clipboard.writeText(text);
                 alert('Copied')

                this.isCopied = true;
            } catch (err) {
                console.warn("Clipboard API failed, using fallback:", err);
                this.fallbackCopy(text);
                }
            } else {
                this.fallbackCopy(text);
            }
    },
    fallbackCopy(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.setAttribute('readonly', true);
      textArea.setAttribute('contenteditable', true);

      document.body.appendChild(textArea);
      textArea.style.position = "absolute";
      textArea.style.left = "-9999px"; // Hide off-screen
      textArea.select();

      try {
        const successful = document.execCommand("copy"); // Fallback for Safari
        if (successful) {
            this.isCopied = true;
        } else {
          console.error("Fallback copy failed.");
        }
      } catch (err) {
        console.error("Fallback copy failed:", err);
      }

      document.body.removeChild(textArea);
    },
    }
}
</script>
<style scoped>
.imgTag{
  width: 95%;
  height: auto;
  border-radius: 8px;
}
.activeClass {
  background-color: #1467BF !important;
  color: white !important;
  padding: 0px !important;
  margin: 0px !important;
  box-shadow: 0px 0px 28px 0px #1366be4d !important;
}
.defaultClass {
  background-color: white !important;
  color: black !important;
  opacity: 80% !important;
  padding: 0px !important;
  margin: 0px !important;

}
.specialistName{     
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    color: #828282;
}
.headertext{
    font-size: 20px;
    font-weight: bold;
    font-family: Inter;
}
</style>